import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import '@/plugins/main.scss'
import { createVuetify } from 'vuetify'
import { id, en } from "vuetify/locale"

const vuetify = createVuetify({
    theme: {
        defaultTheme: 'customTheme',
        defaultAssets: {
            font: false,
        },
        themes: {
            customTheme: {
                // dark: false
                colors: {
                    "primary": "#0854D7",
                    "information": "#BD4640",
                    "widget-color": "#0854D7"
                }
            }
        }
    },
    locale: {
        locale: "id",
        fallback: "en",
        messages: { id, en }
    }
})

export default vuetify